import { telemetryLogger as logger } from '../../Telemetry.logger';
import { shouldHandleAppSessionEvent } from '../../TelemetryEventOverride';

import type { TelemetryEventName } from '../../TelemetryEvent';
import type { TelemetryEventOverride } from '../../TelemetryEventOverride';

export const mixpanelEventOverrides: MixpanelEventOverrides = {
  'app.session'({ event }) {
    const shouldHandle = shouldHandleAppSessionEvent(event);

    logger.info(
      `'app.session' ${shouldHandle ? 'send' : 'ignore'} payload: ${JSON.stringify(event.payload)}`,
    );

    return { event: shouldHandle ? event : undefined };
  },

  'app.page_view': () => ({}), // not used for mixpanel.

  'ga.view_item': () => ({}),
  'ga.view_cart': () => ({}),
  'ga.begin_checkout': () => ({}),

  // `products` is the whole menu and is only used by Google Analytics. Strip it
  // to stay under the Mixpanel property size limit.
  'menu.view': ({ event: { name, payload } }) => {
    const { products: _products, ...payloadWithoutProducts } = payload ?? {};

    return { event: { name, payload: payloadWithoutProducts } };
  },

  'dietary-restrictions.select': ({ context, event }) => ({
    // Sends the event.
    event,
    // Sets the dietary restriction user property.
    post() {
      const { restriction, selected } = event.payload;

      if (restriction) {
        context.setCustomerProperty(`dietary.${restriction}`, Boolean(selected));
      }
    },
  }),
};

// –– TYPES –––––––––––––––––––––––––––

type MixpanelEventOverrides = {
  readonly [Name in TelemetryEventName]?: TelemetryEventOverride<Name, MixpanelEvent>;
};

export type MixpanelEvent = Readonly<{
  name: string;
  payload?: Record<string, unknown>;
}>;
